import Vue from 'vue';

import Multiselect from 'vue-multiselect';

Multiselect.props = {
  /**
   * String to show when pointing to an option
   * @default 'Press enter to select'
   * @type {String}
   */
  selectLabel: {
    type: String,
    // default: 'Seçmek için tıklayın.'
    default: '',
    // default: 'Press enter to select'
  },
  allowEmpty: {
    type: Boolean,
    default: true,
  },
  openDirection: {
    type: String,
    default: 'auto',
  },
  /**
   * String to show next to selected option
   * @default 'Selected'
   * @type {String}
   */
  selectedLabel: {
    type: String,
    // default: 'Seçildi'
    default: '',
  },
  /**
   * String to show when pointing to an alredy selected option
   * @default 'Press enter to remove'
   * @type {String}
   */
  deselectLabel: {
    type: String,
    // default: 'Seçimi kaldırmak için tıklayın'
    default: '',
  },
  /**
   * Decide whether to show pointer labels
   * @default true
   * @type {Boolean}
   */
  showLabels: {
    type: Boolean,
    default: true,
  },
  /**
   * Decide whether to show no result field
   * @default true
   * @type {Boolean}
   */
  showNoResults: {
    type: Boolean,
    default: true,
  },
  /**
   * Limit the display of selected options. The rest will be hidden within the limitText string.
   * @default 'label'
   * @type {String}
   */
  limit: {
    type: Number,
    default: 99999,
  },
  /**
   * Sets maxHeight style value of the dropdown
   * @default 300
   * @type {Integer}
   */
  maxHeight: {
    type: Number,
    default: 300,
  },
  /**
   * Function that process the message shown when selected
   * elements pass the defined limit.
   * @default 'and * more'
   * @param {Int} count Number of elements more than limit
   * @type {Function}
   */
  limitText: {
    type: Function,
    default: (count) => `and ${count} more`,
  },
  /**
   * Set true to trigger the loading spinner.
   * @default False
   * @type {Boolean}
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * Disables the multiselect if true.
   * @default false
   * @type {Boolean}
   */
  disabled: {
    type: Boolean,
    default: false,
  },
};

Vue.component('Multiselect', Multiselect);
